import { useNavigate } from 'react-router-dom';
import BottomNav from '@/components/BottomNav';

const menuItems = [
  { icon: 'ri-list-check-3', label: '내 준비 상태', action: 'status' },
  { icon: 'ri-clipboard-line', label: '내 진단 결과', action: 'diagnosis' },
  { icon: 'ri-bookmark-line', label: '저장한 업체', action: 'saved' },
  { icon: 'ri-file-list-line', label: '받은 견적', action: 'quotes' },
  { icon: 'ri-chat-1-line', label: '상담 내역', action: 'consultations' },
  { icon: 'ri-share-line', label: '공유하기', action: 'share' },
];

export default function My() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-cream flex flex-col">
      <div className="bg-navy px-5 pt-8 pb-6">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center">
            <i className="ri-user-3-line text-white text-xl" />
          </div>
          <div>
            <p className="text-white font-bold text-lg">지혜님</p>
            <p className="text-cream-dark text-sm">2026년 6월 웨딩</p>
          </div>
        </div>
        <div className="flex gap-4 mt-6">
          <div className="flex-1 bg-white/10 rounded-xl p-3 text-center">
            <p className="text-white font-bold text-lg">2/3</p>
            <p className="text-cream-dark text-xs mt-0.5">준비 진행</p>
          </div>
          <div className="flex-1 bg-white/10 rounded-xl p-3 text-center">
            <p className="text-white font-bold text-lg">2</p>
            <p className="text-cream-dark text-xs mt-0.5">받은 견적</p>
          </div>
          <div className="flex-1 bg-white/10 rounded-xl p-3 text-center">
            <p className="text-white font-bold text-lg">0</p>
            <p className="text-cream-dark text-xs mt-0.5">저장 업체</p>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-5 py-6">
        <div className="bg-white rounded-2xl border border-cream-dark overflow-hidden">
          {menuItems.map((item, i) => (
            <button
              key={item.action}
              onClick={() => {
                if (item.action === 'quotes') navigate('/quotes');
                if (item.action === 'status') navigate('/home');
                if (item.action === 'diagnosis') navigate('/result/dress');
              }}
              className={`w-full flex items-center gap-4 px-5 py-4 text-left cursor-pointer hover:bg-cream transition-colors ${
                i < menuItems.length - 1 ? 'border-b border-cream-dark' : ''
              }`}
            >
              <div className="w-9 h-9 rounded-lg bg-cream flex items-center justify-center">
                <i className={`${item.icon} text-navy`} />
              </div>
              <span className="text-navy text-sm font-medium flex-1">{item.label}</span>
              <div className="w-6 h-6 flex items-center justify-center text-beige-dark">
                <i className="ri-arrow-right-s-line" />
              </div>
            </button>
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}